<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visibleLocal"
    width="92vw"
    top="4vh"
    :append-to-body="true"
    :modal="false"
    :lock-scroll="false"
    :close-on-click-modal="true"
    custom-class="att-preview-dialog"
    @close="onClose"
  >
    <div v-if="loading" class="muted">{{ $t('common.loading') }}</div>
    <div v-else-if="!detail" class="muted">-</div>
    <div v-else>
      <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;">
        <div style="font-family:'Poppins',sans-serif;font-weight:600;">{{ detail.title }}</div>
        <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
          <span class="tag-pill">{{ caseStatusLabel(detail) }}</span>
          <span class="tag-pill">{{ flowLabel(detail) }}</span>
        </div>
      </div>
      <div class="muted" style="margin-top:6px;">{{ detail.createdAt ? new Date(detail.createdAt).toLocaleString() : '-' }}</div>

      <div class="chat" style="margin-top:12px;">
        <div v-for="b in displayBlocks" :key="b.key">
          <div v-if="b.type==='separator'" class="chat__separator">
            <div class="chat__separatorLine" />
            <span class="tag-pill tag-pill--warn chat__separatorTag">{{ b.label }}</span>
          </div>
          <div v-else :class="['chat__row', b.alignRight ? 'chat__row--mine' : 'chat__row--other']">
            <div :class="['chat__bubble', b.alignRight ? 'chat__bubble--mine' : 'chat__bubble--other']">
              <div class="chat__meta">
                <span class="chat__name">{{ b.senderName || '-' }}</span>
                <span class="muted" style="margin-left:auto;">{{ b.createdAt ? new Date(b.createdAt).toLocaleString() : '-' }}</span>
              </div>
              <div v-if="b.resultCode" style="margin-top:6px;">
                <span class="tag-pill tag-pill--warn">{{ trDisputeResult(b.resultCode) }}</span>
              </div>
              <div v-if="b.text" class="chat__text">{{ b.text }}</div>
              <div v-if="b.allFileIds && b.allFileIds.length>0" style="margin-top:10px;">
                <AttachmentGallery :file-ids="b.allFileIds" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top:14px; display:flex; gap:10px; flex-wrap:wrap;">
        <el-button v-if="canUrgeCase" type="warning" plain :loading="urging" @click="doUrgeCase">
          {{ $t('ticket.urge') }}
        </el-button>
        <el-button v-if="canUrgeDispute" type="warning" plain :loading="urging" @click="doUrgeDispute">
          {{ $t('ticket.urgeDispute') }}
        </el-button>
        <el-button v-if="canSubmittedResubmit" type="primary" class="btn-glass" @click="openResubmit=true">
          {{ $t('ticket.resubmit') }}
        </el-button>
        <el-button v-if="canSubmittedResubmit && detail.canCancel" @click="cancelCase" :loading="actionLoading">
          {{ $t('ticket.cancelTicket') }}
        </el-button>
        <el-button v-if="canSubmittedCancel" @click="cancelCase" :loading="actionLoading">
          {{ $t('ticket.cancelTicket') }}
        </el-button>
        <el-button v-if="canSubmittedDispute" type="primary" class="btn-glass" @click="openSubmittedDispute=true">
          {{ $t('ticket.createDispute') }}
        </el-button>

        <el-button v-if="canReturnUser" type="primary" class="btn-glass" @click="openReturn=true">
          {{ $t('handler.replyReturn') }}
        </el-button>
        <el-button v-if="canEscalate" type="primary" class="btn-glass" @click="openEscalate=true">
          {{ detail.status === 'ESCALATED_RETURNED' ? $t('secondary.resubmitToHandler') : $t('handler.replyEscalate') }}
        </el-button>
        <el-button v-if="canCloseCase" @click="openClose=true">
          {{ $t('handler.replyClose') }}
        </el-button>

        <el-button v-if="canDisputeClose" type="primary" class="btn-glass" @click="openDisputeClose=true">
          {{ $t('handler.disputeClose') }}
        </el-button>
        <el-button v-if="canDisputeEscalate" @click="openDisputeEscalate=true">
          {{ $t('handler.disputeEscalate') }}
        </el-button>
      </div>
    </div>

    <el-dialog
      :title="$t('ticket.resubmit')"
      :visible.sync="openResubmit"
      width="560px"
      top="10vh"
      :append-to-body="true"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="onResubmitClose"
    >
      <el-input v-model="resubmitContent" type="textarea" :rows="6" />
      <div style="margin-top:10px;">
        <FileUploader ref="resubmitUploader" v-model="resubmitFiles" @uploading-change="resubmitUploading = $event" />
      </div>
      <span slot="footer">
        <el-button @click="openResubmit=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="actionLoading || resubmitUploading" :disabled="actionLoading || resubmitUploading" @click="doResubmit">{{ $t('common.submit') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('handler.replyReturn')"
      :visible.sync="openReturn"
      width="560px"
      top="10vh"
      :append-to-body="true"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="onReturnClose"
    >
      <el-input v-model="returnContent" type="textarea" :rows="6" />
      <div style="margin-top:10px;">
        <FileUploader ref="returnUploader" v-model="returnFiles" @uploading-change="returnUploading = $event" />
      </div>
      <span slot="footer">
        <el-button @click="openReturn=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="actionLoading || returnUploading" :disabled="actionLoading || returnUploading" @click="doReturn">{{ $t('common.submit') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="detail && detail.status === 'ESCALATED_RETURNED' ? $t('secondary.resubmitToHandler') : $t('handler.replyEscalate')"
      :visible.sync="openEscalate"
      width="560px"
      top="10vh"
      :append-to-body="true"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="onEscalateClose"
    >
      <el-input v-model="escalateContent" type="textarea" :rows="6" />
      <div style="margin-top:10px;">
        <FileUploader ref="escalateUploader" v-model="escalateFiles" @uploading-change="escalateUploading = $event" />
      </div>
      <span slot="footer">
        <el-button @click="openEscalate=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="actionLoading || escalateUploading" :disabled="actionLoading || escalateUploading" @click="doEscalate">{{ $t('common.submit') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('handler.replyClose')"
      :visible.sync="openClose"
      width="560px"
      top="10vh"
      :append-to-body="true"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="onCloseCaseClose"
    >
      <el-input v-model="closeContent" type="textarea" :rows="6" />
      <div style="margin-top:10px;">
        <FileUploader ref="closeUploader" v-model="closeFiles" @uploading-change="closeUploading = $event" />
      </div>
      <span slot="footer">
        <el-button @click="openClose=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="actionLoading || closeUploading" :disabled="actionLoading || closeUploading" @click="doCloseCase">{{ $t('common.submit') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('handler.disputeClose')"
      :visible.sync="openDisputeClose"
      width="560px"
      top="10vh"
      :append-to-body="true"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="onDisputeCloseClose"
    >
      <el-form label-position="top">
        <el-form-item :label="$t('field.status')">
          <el-select v-model="disputeReply.result" style="width:100%;">
            <el-option :label="$t('dispute.result.RESOLVED')" value="RESOLVED" />
            <el-option :label="$t('dispute.result.REJECTED')" value="REJECTED" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('field.message')">
          <el-input v-model="disputeReply.content" type="textarea" :rows="6" />
        </el-form-item>
        <el-form-item :label="$t('field.attachments')">
          <FileUploader ref="disputeCloseUploader" v-model="disputeCloseFiles" @uploading-change="disputeCloseUploading = $event" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="openDisputeClose=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="actionLoading || disputeCloseUploading" :disabled="actionLoading || disputeCloseUploading" @click="doDisputeClose">{{ $t('common.submit') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('handler.disputeEscalate')"
      :visible.sync="openDisputeEscalate"
      width="560px"
      top="10vh"
      :append-to-body="true"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="onDisputeEscalateClose"
    >
      <el-input v-model="disputeEscalateContent" type="textarea" :rows="6" />
      <div style="margin-top:10px;">
        <FileUploader ref="disputeEscalateUploader" v-model="disputeEscalateFiles" @uploading-change="disputeEscalateUploading = $event" />
      </div>
      <span slot="footer">
        <el-button @click="openDisputeEscalate=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="actionLoading || disputeEscalateUploading" :disabled="actionLoading || disputeEscalateUploading" @click="doDisputeEscalate">{{ $t('common.submit') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('ticket.createDispute')"
      :visible.sync="openSubmittedDispute"
      width="560px"
      top="10vh"
      :append-to-body="true"
      :modal="false"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="onSubmittedDisputeClose"
    >
      <el-input v-model="submittedDisputeContent" type="textarea" :rows="6" />
      <div style="margin-top:10px;">
        <FileUploader ref="submittedDisputeUploader" v-model="submittedDisputeFiles" @uploading-change="submittedDisputeUploading = $event" />
      </div>
      <span slot="footer">
        <el-button @click="openSubmittedDispute=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" class="btn-glass" :loading="actionLoading || submittedDisputeUploading" :disabled="actionLoading || submittedDisputeUploading" @click="doSubmittedDispute">{{ $t('common.submit') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  secondaryCaseDetail,
  secondaryMarkCaseSeen,
  secondaryReplyEscalate,
  secondaryReplyReturn,
  secondaryReplyClose,
  secondaryResubmitCase,
  secondaryCancelCase,
  secondaryCreateDispute,
  secondaryEscalateDispute,
  secondaryCloseDispute,
  secondaryUrgeCase,
  secondaryUrgeDispute
} from '../api/secondary';
import FileUploader from './FileUploader.vue';
import AttachmentGallery from './AttachmentGallery.vue';
import { parseMessage } from '../utils/message';
import { caseStatusLabel as formatCaseStatusLabel, flowLabel as formatFlowLabel, isActiveDispute } from '../utils/caseDisplay';

export default {
  name: 'SecondaryCaseDialog',
  components: { FileUploader, AttachmentGallery },
  props: {
    value: { type: Boolean, default: false },
    caseNo: { type: String, default: '' },
    mode: { type: String, default: 'work' }
  },
  data() {
    return {
      visibleLocal: false,
      loading: false,
      actionLoading: false,
      urging: false,
      detail: null,
      openResubmit: false,
      resubmitContent: '',
      resubmitFiles: [],
      resubmitUploading: false,
      openReturn: false,
      returnContent: '',
      returnFiles: [],
      returnUploading: false,
      openEscalate: false,
      escalateContent: '',
      escalateFiles: [],
      escalateUploading: false,
      openClose: false,
      closeContent: '',
      closeFiles: [],
      closeUploading: false,
      openDisputeClose: false,
      disputeReply: { result: 'RESOLVED', content: '' },
      disputeCloseFiles: [],
      disputeCloseUploading: false,
      openDisputeEscalate: false,
      disputeEscalateContent: '',
      disputeEscalateFiles: [],
      disputeEscalateUploading: false,
      openSubmittedDispute: false,
      submittedDisputeContent: '',
      submittedDisputeFiles: [],
      submittedDisputeUploading: false
    };
  },
  computed: {
    dialogTitle() {
      return this.detail ? `${this.$t('ticket.ticketNo')} ${this.detail.caseNo}` : this.$t('ticket.ticketNo');
    },
    submittedMode() {
      return this.mode === 'submitted';
    },
    currentUserId() {
      return this.$store && this.$store.state && this.$store.state.user ? this.$store.state.user.id : null;
    },
    isSelfSubmittedCase() {
      return !!(
        this.detail &&
        this.detail.createdBy != null &&
        this.currentUserId != null &&
        String(this.detail.createdBy) === String(this.currentUserId)
      );
    },
    isWorkCase() {
      return !this.isSelfSubmittedCase;
    },
    canSubmittedResubmit() {
      return this.isSelfSubmittedCase && this.detail && this.detail.status === 'WAITING_RESUBMIT';
    },
    canSubmittedCancel() {
      return this.isSelfSubmittedCase && this.detail && this.detail.canCancel && !this.canSubmittedResubmit;
    },
    canSubmittedDispute() {
      return !!(
        this.detail &&
        this.detail.status === 'CLOSED' &&
        !this.detail.dispute &&
        !isActiveDispute(this.detail) &&
        this.detail.createdBy != null &&
        this.currentUserId != null &&
        String(this.detail.createdBy) === String(this.currentUserId)
      );
    },
    canReturnUser() {
      return this.isWorkCase && this.detail && (this.detail.status === 'PENDING_SECONDARY' || this.detail.status === 'ESCALATED_RETURNED');
    },
    canEscalate() {
      return this.isWorkCase && this.detail && (this.detail.status === 'PENDING_SECONDARY' || this.detail.status === 'ESCALATED_RETURNED');
    },
    canCloseCase() {
      return this.isWorkCase && this.detail && this.detail.status === 'PENDING_SECONDARY';
    },
    canDisputeClose() {
      return this.isWorkCase && this.detail && this.detail.dispute && (
        this.detail.dispute.status === 'DISPUTE_SECONDARY_CREATED' ||
        this.detail.dispute.status === 'DISPUTE_SECONDARY_IN_PROGRESS'
      );
    },
    canDisputeEscalate() {
      return this.canDisputeClose;
    },
    canUrgeCase() {
      if (!this.detail) return false;
      if (this.isSelfSubmittedCase) return ['PENDING', 'IN_PROGRESS'].includes(this.detail.status);
      return this.isWorkCase && ['ESCALATED', 'IN_PROGRESS'].includes(this.detail.status);
    },
    canUrgeDispute() {
      const st = this.detail && this.detail.dispute ? this.detail.dispute.status : '';
      return ['DISPUTE_CREATED', 'DISPUTE_IN_PROGRESS'].includes(st);
    },
    resubmitFileIds() {
      return this.ids(this.resubmitFiles);
    },
    returnFileIds() {
      return this.ids(this.returnFiles);
    },
    escalateFileIds() {
      return this.ids(this.escalateFiles);
    },
    closeFileIds() {
      return this.ids(this.closeFiles);
    },
    disputeCloseFileIds() {
      return this.ids(this.disputeCloseFiles);
    },
    disputeEscalateFileIds() {
      return this.ids(this.disputeEscalateFiles);
    },
    submittedDisputeFileIds() {
      return this.ids(this.submittedDisputeFiles);
    },
    displayMessages() {
      const list = this.detail && this.detail.messages ? this.detail.messages : [];
      return list.map((m) => {
        const parsed = parseMessage(m && m.content ? m.content : '');
        const ids = [];
        const seen = new Set();
        const add = (x) => {
          if (x == null) return;
          const n = Number(x);
          if (!n || seen.has(n)) return;
          seen.add(n);
          ids.push(n);
        };
        (m && m.fileIds ? m.fileIds : []).forEach(add);
        (parsed.fileIds || []).forEach(add);
        return {
          ...m,
          mine: !!(m && m.mine),
          alignRight: !!(m && m.mine),
          text: parsed.text,
          resultCode: parsed.resultCode,
          allFileIds: ids
        };
      });
    },
    displayBlocks() {
      const ms = this.displayMessages || [];
      const blocks = [];
      let inserted = false;
      const hasDispute = !!(this.detail && this.detail.dispute);
      const disputeLabel = hasDispute
        ? `${this.$t('ticket.disputeLabel')}：${this.$t(`status.dispute.${this.detail.dispute.status}`)}`
        : '';
      ms.forEach((m, idx) => {
        if (hasDispute && !inserted && m && String(m.phase || '') === 'DISPUTE') {
          blocks.push({ type: 'separator', key: `sep_dispute_${this.detail.dispute.id || 'x'}`, label: disputeLabel });
          inserted = true;
        }
        blocks.push({ ...m, type: 'message', key: `m_${m.id != null ? m.id : idx}` });
      });
      if (hasDispute && !inserted) {
        blocks.push({ type: 'separator', key: `sep_dispute_${this.detail.dispute.id || 'x'}`, label: disputeLabel });
      }
      return blocks;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.visibleLocal = !!v;
        if (v) this.load();
      }
    },
    visibleLocal(v) {
      this.$emit('input', v);
    },
    caseNo() {
      if (this.visibleLocal) this.load();
    }
  },
  methods: {
    caseStatusLabel(row) {
      return formatCaseStatusLabel(this, row);
    },
    flowLabel(row) {
      return formatFlowLabel(this, row);
    },
    ids(list) {
      return (list || []).map((x) => (x ? x.id : null)).filter((x) => x != null);
    },
    trDisputeResult(code) {
      const k = `dispute.result.${code}`;
      try {
        if (this.$i18n && this.$i18n.te && this.$i18n.te(k)) return this.$t(k);
      } catch (e) {}
      return code;
    },
    async load() {
      if (!this.caseNo) return;
      this.loading = true;
      try {
        this.detail = await secondaryCaseDetail(this.caseNo);
        this.$emit('reminder-read', this.caseNo);
        if (this.detail && this.detail.status === 'CLOSED') {
          try {
            await secondaryMarkCaseSeen(this.caseNo);
            this.detail.hasNewNotice = false;
            this.$store.dispatch('refreshSecondaryBadges');
            this.$store.commit('bumpVersion', 'secondaryCases');
          } catch (e) {}
        }
      } finally {
        this.loading = false;
      }
    },
    bump() {
      this.$store.commit('bumpVersion', 'secondaryCases');
      this.$store.commit('bumpVersion', 'disputes');
      this.$store.dispatch('refreshSecondaryBadges');
      this.$emit('changed');
    },
    onClose() {
      this.detail = null;
      this.openResubmit = false;
      this.openReturn = false;
      this.openEscalate = false;
      this.openClose = false;
      this.openDisputeClose = false;
      this.openDisputeEscalate = false;
      this.openSubmittedDispute = false;
      this.onResubmitClose();
      this.onReturnClose();
      this.onEscalateClose();
      this.onCloseCaseClose();
      this.onDisputeCloseClose();
      this.onDisputeEscalateClose();
      this.onSubmittedDisputeClose();
    },
    clearUploader(refName) {
      try {
        if (this.$refs[refName] && this.$refs[refName].cancelUploads) this.$refs[refName].cancelUploads();
      } catch (e) {}
    },
    markCommitted(refName, ids) {
      try {
        if (this.$refs[refName] && this.$refs[refName].markCommitted) this.$refs[refName].markCommitted(ids);
      } catch (e) {}
    },
    ensureNotUploading(refName) {
      try {
        if (this.$refs[refName] && this.$refs[refName].isUploading && this.$refs[refName].isUploading()) {
          this.$message.warning(this.$t('common.uploading'));
          return false;
        }
      } catch (e) {}
      return true;
    },
    onResubmitClose() {
      this.clearUploader('resubmitUploader');
      this.resubmitContent = '';
      this.resubmitFiles = [];
      this.resubmitUploading = false;
    },
    onReturnClose() {
      this.clearUploader('returnUploader');
      this.returnContent = '';
      this.returnFiles = [];
      this.returnUploading = false;
    },
    onEscalateClose() {
      this.clearUploader('escalateUploader');
      this.escalateContent = '';
      this.escalateFiles = [];
      this.escalateUploading = false;
    },
    onCloseCaseClose() {
      this.clearUploader('closeUploader');
      this.closeContent = '';
      this.closeFiles = [];
      this.closeUploading = false;
    },
    onDisputeCloseClose() {
      this.clearUploader('disputeCloseUploader');
      this.disputeReply = { result: 'RESOLVED', content: '' };
      this.disputeCloseFiles = [];
      this.disputeCloseUploading = false;
    },
    onDisputeEscalateClose() {
      this.clearUploader('disputeEscalateUploader');
      this.disputeEscalateContent = '';
      this.disputeEscalateFiles = [];
      this.disputeEscalateUploading = false;
    },
    onSubmittedDisputeClose() {
      this.clearUploader('submittedDisputeUploader');
      this.submittedDisputeContent = '';
      this.submittedDisputeFiles = [];
      this.submittedDisputeUploading = false;
    },
    async doResubmit() {
      if (!this.resubmitContent) return this.$message.error(this.$t('ticket.requiredContent'));
      if (!this.ensureNotUploading('resubmitUploader')) return;
      this.actionLoading = true;
      try {
        await secondaryResubmitCase(this.caseNo, { content: this.resubmitContent, fileIds: this.resubmitFileIds });
        this.markCommitted('resubmitUploader', this.resubmitFileIds);
        this.openResubmit = false;
        this.onResubmitClose();
        this.bump();
        await this.load();
      } finally {
        this.actionLoading = false;
      }
    },
    async cancelCase() {
      this.actionLoading = true;
      try {
        await secondaryCancelCase(this.caseNo);
        this.bump();
        await this.load();
      } finally {
        this.actionLoading = false;
      }
    },
    async doUrgeCase() {
      if (!this.canUrgeCase) return;
      this.urging = true;
      try {
        await secondaryUrgeCase(this.caseNo);
        this.$message.success(this.$t('ticket.urgeSent'));
      } finally {
        this.urging = false;
      }
    },
    async doUrgeDispute() {
      if (!this.canUrgeDispute || !this.detail || !this.detail.dispute) return;
      this.urging = true;
      try {
        await secondaryUrgeDispute(this.detail.dispute.id);
        this.$message.success(this.$t('ticket.urgeSent'));
      } finally {
        this.urging = false;
      }
    },
    async doReturn() {
      if (!this.returnContent) return this.$message.error(this.$t('ticket.requiredContent'));
      if (!this.ensureNotUploading('returnUploader')) return;
      this.actionLoading = true;
      try {
        await secondaryReplyReturn(this.caseNo, { content: this.returnContent, fileIds: this.returnFileIds });
        this.markCommitted('returnUploader', this.returnFileIds);
        this.openReturn = false;
        this.onReturnClose();
        this.bump();
        await this.load();
      } finally {
        this.actionLoading = false;
      }
    },
    async doEscalate() {
      if (!this.escalateContent) return this.$message.error(this.$t('ticket.requiredContent'));
      if (!this.ensureNotUploading('escalateUploader')) return;
      this.actionLoading = true;
      try {
        await secondaryReplyEscalate(this.caseNo, { content: this.escalateContent, fileIds: this.escalateFileIds });
        this.markCommitted('escalateUploader', this.escalateFileIds);
        this.openEscalate = false;
        this.onEscalateClose();
        this.bump();
        await this.load();
      } finally {
        this.actionLoading = false;
      }
    },
    async doCloseCase() {
      if (!this.closeContent) return this.$message.error(this.$t('ticket.requiredContent'));
      if (!this.ensureNotUploading('closeUploader')) return;
      this.actionLoading = true;
      try {
        await secondaryReplyClose(this.caseNo, { content: this.closeContent, fileIds: this.closeFileIds });
        this.markCommitted('closeUploader', this.closeFileIds);
        this.openClose = false;
        this.onCloseCaseClose();
        this.bump();
        await this.load();
      } finally {
        this.actionLoading = false;
      }
    },
    async doDisputeClose() {
      if (!this.detail || !this.detail.dispute || !this.detail.dispute.id) return;
      if (!this.disputeReply.content) return this.$message.error(this.$t('ticket.requiredContent'));
      if (!this.ensureNotUploading('disputeCloseUploader')) return;
      this.actionLoading = true;
      try {
        await secondaryCloseDispute(this.detail.dispute.id, { result: this.disputeReply.result, content: this.disputeReply.content, fileIds: this.disputeCloseFileIds });
        this.markCommitted('disputeCloseUploader', this.disputeCloseFileIds);
        this.openDisputeClose = false;
        this.onDisputeCloseClose();
        this.bump();
        await this.load();
      } finally {
        this.actionLoading = false;
      }
    },
    async doDisputeEscalate() {
      if (!this.detail || !this.detail.dispute || !this.detail.dispute.id) return;
      if (!this.disputeEscalateContent) return this.$message.error(this.$t('ticket.requiredContent'));
      if (!this.ensureNotUploading('disputeEscalateUploader')) return;
      this.actionLoading = true;
      try {
        await secondaryEscalateDispute(this.detail.dispute.id, { content: this.disputeEscalateContent, fileIds: this.disputeEscalateFileIds });
        this.markCommitted('disputeEscalateUploader', this.disputeEscalateFileIds);
        this.openDisputeEscalate = false;
        this.onDisputeEscalateClose();
        this.bump();
        await this.load();
      } finally {
        this.actionLoading = false;
      }
    },
    async doSubmittedDispute() {
      if (!this.submittedDisputeContent) return this.$message.error(this.$t('ticket.requiredContent'));
      if (!this.ensureNotUploading('submittedDisputeUploader')) return;
      this.actionLoading = true;
      try {
        await secondaryCreateDispute(this.caseNo, { content: this.submittedDisputeContent, fileIds: this.submittedDisputeFileIds });
        this.markCommitted('submittedDisputeUploader', this.submittedDisputeFileIds);
        this.openSubmittedDispute = false;
        this.onSubmittedDisputeClose();
        this.bump();
        await this.load();
      } finally {
        this.actionLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.chat {
  display: grid;
  gap: 10px;
}
.chat__row {
  display: flex;
}
.chat__row--mine {
  justify-content: flex-end;
}
.chat__row--other {
  justify-content: flex-start;
}
.chat__bubble {
  width: min(720px, 100%);
  border-radius: 16px;
  padding: 12px;
  border: 1px solid rgba(226, 232, 240, 0.9);
}
.chat__bubble--mine {
  background: rgba(37, 99, 235, 0.10);
  border-color: rgba(37, 99, 235, 0.20);
}
.chat__bubble--other {
  background: rgba(255, 255, 255, 0.55);
}
.chat__meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
}
.chat__name {
  font-weight: 600;
}
.chat__text {
  margin-top: 8px;
  white-space: pre-wrap;
  line-height: 1.6;
}
.chat__separator {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
}
.chat__separatorLine {
  flex: 1;
  height: 1px;
  background: rgba(226, 232, 240, 0.95);
}
.chat__separatorTag {
  white-space: nowrap;
}
</style>
